// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1x-e";
export var animationRelative = "_1x-d";
export var backdropBlur = "_1x-0";
export var detailLabelCell = "_1x-q";
export var detailTable = "_1x-p";
export var detailValueCell = "_1x-r";
export var documentTypeIcon = "_1x-y";
export var documentTypeOption = "_1x-x";
export var dropdownMatchDatePicker = "_1x-3";
export var evidenceCardContent = "_1x-w";
export var gorgiasTicketCard = "_1x-s";
export var iconTertiary = "_1x-z";
export var integrationCard = "_1x-1";
export var integrationLogoBox = "_1x-2";
export var mainColumnSticky = "_1x-v";
export var maxWidthContainer = "_1x-t";
export var modalContentBody = "_1x-a";
export var modalHeaderImage = "_1x-5";
export var modalImageLabel = "_1x-7";
export var modalImageOverlay = "_1x-6";
export var modalImageSubtitle = "_1x-9";
export var modalImageTitle = "_1x-8";
export var modalImageWrapper = "_1x-4";
export var modalStickyFooter = "_1x-b";
export var sidebarColumn = "_1x-u";
export var timelineLine = "_1x-m";
export var timelineLineBlack = "_1x-o _1x-m";
export var timelineLineGray = "_1x-n _1x-m";
export var timelineLineHeight = "_1x-l";
export var tlDotActivate = "_1x-i";
export var tlDotActivateAnim = "_1x-h";
export var tlDotHide = "_1x-g";
export var tlDotHideAnim = "_1x-f";
export var tlLineActivate = "_1x-k";
export var tlLineActivateAnim = "_1x-j";
export var uploadedFileRow = "_1x-c";